import { DocumentViewerModal, type DocumentViewerModalProps } from '@dataroom/shared';
import type { RoomDocument } from '@dataroom/shared';
import { ManageDocumentDialog } from './ManageDocumentDialog';

interface DocumentPreviewModalProps {
  /** The room the document belongs to — used to build the content endpoint. */
  roomId: string;
  /** The document being previewed. */
  document: RoomDocument;
  onClose: () => void;
  /** Opens the redaction review for this document (see DocumentViewerModal). */
  onReviewRedaction?: (document: RoomDocument) => void;
  /** The viewer may offer "Manage document" (re-file it, confirm its date):
   * the room admin's pages, where re-filing is already offered. Default off. */
  canManage?: boolean;
  /** Start on the original file (a file we couldn't read — see DocumentViewerModal). */
  original?: boolean;
  /** What the admin can do about a file we couldn't read (see DocumentViewerModal). */
  renderUnreadableOptions?: DocumentViewerModalProps['renderUnreadableOptions'];
}

/**
 * The room admin's document viewer: the shared data-room viewer
 * ({@link DocumentViewerModal} — what buyers see, ADR-0064) plus, where
 * re-filing is offered, the admin's "Manage document" dialog.
 */
export function DocumentPreviewModal({
  roomId,
  document,
  onClose,
  onReviewRedaction,
  canManage = false,
  original,
  renderUnreadableOptions,
}: DocumentPreviewModalProps) {
  return (
    <DocumentViewerModal
      roomId={roomId}
      document={document}
      onClose={onClose}
      onReviewRedaction={onReviewRedaction}
      original={original}
      renderUnreadableOptions={renderUnreadableOptions}
      renderManage={
        canManage
          ? (close) => <ManageDocumentDialog roomId={roomId} document={document} onClose={close} />
          : undefined
      }
    />
  );
}
